import {LineItemModel} from '../../../../domain/models/checkout/LineItem.model';
import {Violation} from '../../Violations/Violation';
import React from 'react';
import {useControllerProps} from '../../Widget/ControllerContext';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {ViolationModel} from '../../../../domain/models/checkout/Violation.model';
import {ItemOutOfStock} from '../../../../common/components/Item/ItemOutOfStock/ItemOutOfStock';
import {LineItemDataHooks} from './LineItem';

export const LineItemAdditionalInfo = ({
  lineItem,
  isItemOutOfStock,
  lineItemViolation,
}: {
  lineItem: LineItemModel;
  isItemOutOfStock: boolean;
  lineItemViolation?: ViolationModel;
}) => {
  const {
    checkoutStore: {removeLineItem},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  /* istanbul ignore else */
  if (isItemOutOfStock) {
    return (
      <ItemOutOfStock
        dataHook={LineItemDataHooks.OutOfStock}
        message={localeKeys.checkout.order_summary.item_out_of_stock_error()}
        removeButtonText={localeKeys.checkout.order_summary.removeFromCartError.cta()}
        removeButtonOnClick={() => void removeLineItem(lineItem.id)}
      />
    );
  } else if (lineItemViolation) {
    return <Violation severity={lineItemViolation.severity} description={lineItemViolation.description} />;
  }
  /* istanbul ignore next */
  return null;
};
